import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://8wslaovsrk.execute-api.eu-north-1.amazonaws.com/prod';
const API_KEY = process.env.REACT_APP_API_KEY || 'dkjUPqvShyfD49ZIFnNsX23VKcoOizbY';

// Configure axios to include API key in all requests
// Note: Backend must configure CORS to allow 'X-API-KEY' header
// Required CORS headers: Access-Control-Allow-Headers: Content-Type, X-API-KEY
axios.defaults.headers.common['X-API-KEY'] = API_KEY;

export const api = {
  // Upload PDF or image and extract biomarkers
  uploadPdf: async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API_BASE_URL}/upload-pdf`, formData, {
      headers: { 
        'X-API-KEY': API_KEY,
        // Don't set Content-Type - let axios set it automatically with boundary
      },
    });
  },

  // Analyze biomarkers
  analyzeBiomarkers: async (biomarkerData: any) => {
    return axios.post(`${API_BASE_URL}/analyze-biomarkers`, {
      biomarker_data: biomarkerData,
    }, {
      headers: {
        'X-API-KEY': API_KEY,
      },
    });
  },

  // Chat with AI
  chat: async (question: string, analysis: any) => {
    return axios.post(`${API_BASE_URL}/chat`, {
      question,
      analysis,
    }, {
      headers: {
        'X-API-KEY': API_KEY,
      },
    });
  },

  // Generate PDF
  generatePdf: async (analysis: any) => {
    return axios.post(`${API_BASE_URL}/generate-pdf`, {
      analysis,
    }, {
      headers: {
        'X-API-KEY': API_KEY,
      },
    });
  },

  // Download PDF
  downloadPdf: async (filename: string) => {
    const response = await axios.get(`${API_BASE_URL}/download-pdf/${filename}`, {
      headers: {
        'X-API-KEY': API_KEY,
      },
      responseType: 'blob',
    });
    // Create a blob URL for download
    const blob = new Blob([response.data], { type: 'application/pdf' });
    return URL.createObjectURL(blob);
  },
};
